import { render, staticRenderFns } from "./RaceImg.vue?vue&type=template&id=055d3527&scoped=true&"
import script from "./RaceImg.vue?vue&type=script&lang=js&"
export * from "./RaceImg.vue?vue&type=script&lang=js&"
import style0 from "./RaceImg.vue?vue&type=style&index=0&id=055d3527&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055d3527",
  null
  
)

export default component.exports